import React, { useState, useEffect, useCallback } from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import {
    Text, View, StyleSheet, ScrollView, TouchableHighlight, TouchableOpacity
} from 'react-native';
import { debounce } from "lodash"
import AppStyles from "../../AppStyles";
import OmsStyles from '../../OmsStyle';
import AppTheme from "../../AppTheme";
import { store } from '../../store/store';
import * as Redux from '../../utils/services/redux/commonRedux';
import { doMultipart } from "../../utils/services/api/API";
import { AppUIVersion, AppVersionCode } from '../../utils/constants/AppConstants';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import * as AlertService from "../../utils/services/AlertLoaderService";
import * as EConsultUtils from "../../utils/services/econsult/EConsultUtils";
import { Avatar } from 'react-native-elements';
import { handleModalBackpress, pwaGUID } from '../CommonService';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { refreshEConsult } from '../../utils/services/econsult/EConsultUtils';
import ActionPopup from '../../utils/modals/ActionPopup';
import ModalContent from '../../utils/constants/ModalContentConstant';
import { backpressBheaviour$, commonModalData$ } from '../../utils/services/subject-behaviour/CommonRxjsService';
import { addFontFamilyStyle, checkAayuSubscriptionValidity } from '../../utils/services/CommonUtils';
import { HorizontalDivider } from '../../utils/widgets/Common-Widget';

const ReviewAnswers = (props) => {

    const [data, updateData] = useState({
        questionList: [{}],
        answerList: {},
        caseCode: '',
        category: '',
        userId: 0,
        userName: '',
        render: false,
    })

    const exitFlowAction = () => {
        props?.navigation?.popToTop()
        props?.navigation.navigate(ScreenRoute.tab_controller_screen);
        setExitFlowPopup({ active: false })
    }

    const [showExitFlowPopup, setShowExitPopup] = useState(false)

    const setExitFlowPopup = (modalData) => {
        handleModalBackpress(modalData, {
            showModal: showExitFlowPopup,
            setModal: setShowExitPopup,
            modalDataSubscriber: modalDataSubscriber
        })
    }

    const modalDataSubscriber = useCallback(debounce((modalData) =>
        commonModalData$.next({ active: modalData.active }), 200), [])

    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.consultationQuestion && reduxState.consultationAnswer)
            console.log('question and answer list', reduxState.consultationQuestion, reduxState.consultationAnswer);
        updateData({
            questionList: reduxState.consultationQuestion,
            answerList: reduxState.consultationAnswer,
            caseCode: reduxState.consultationParams['selectedCategory']['caseCode'],
            category: reduxState.consultationParams['selectedCategory']['cm']['en'],
            userId: reduxState.consultationParams['selectedMember']['id'],
            userName: reduxState.consultationParams['selectedMember']['name'],
            render: true
        });
        backpressBheaviour$.subscribe((backpressData) => {
            if (backpressData.backpressData['reviewQuestionAnswerFlowExit'])
                setExitFlowPopup({ active: true })
        })
    }, []);

    function appendAnswer(reviewAns, appendAns) {
        return reviewAns == '' ? appendAns : reviewAns + ', ' + appendAns;
    }

    function renderAnswer(qData, ansList) {
        var answer = '';
        var ansData = ansList[qData['qid']];
        if (ansData && ansData[qData['qid']]) {
            if (typeof (EConsultUtils.getConsultationAnsValue(qData, ansData)) == "object")
                if (qData['qtype'] == 'IMPIMG')
                    if (Object.keys(EConsultUtils.getConsultationAnsValue(qData, ansData)).length > 1)
                        answer = 'Attached Images'
                    else answer = 'Attached Image'
                else for (var index = 0; index < Object.keys(EConsultUtils.getConsultationAnsValue(qData, ansData)).length; index++) {
                    answer = appendAnswer(answer, EConsultUtils.getConsultationAnsValue(qData, ansData)[index]);
                }
            else answer = appendAnswer(answer, EConsultUtils.getConsultationAnsValue(qData, ansData));
            if (EConsultUtils.getConsultationAnsTextInputValue(qData, ansData))
                answer = appendAnswer(answer, EConsultUtils.getConsultationAnsTextInputValue(qData, ansData));
        } return answer;
    }

    function checkAlternatePhNumber(alternatePhNum, userPhNum) {
        if (alternatePhNum == null || alternatePhNum == '' ||
            alternatePhNum == 0 || alternatePhNum.length < 10)
            return userPhNum;
        else return alternatePhNum;
    }

    function formatAnswerList(ansList) {
        var answerObject = {}
        var ansQIDList = Object.keys(ansList)
        ansQIDList.forEach((ansQID, index) => {
            answerObject[ansQID] = ansList[ansQID][ansQID]
        })
        return answerObject;
    }

    async function dataURItoBlob(dataURI, form, handle) {
        let blob = await (await fetch(dataURI)).blob();
        form.append('file', blob, handle);
        return blob;
    }

    async function createConsultation() {
        AlertService.loaderModal.setLoader(true, 0.6)
        const reduxState = store.getState();
        const params: any = {
            ln: 'en',
            uiVersion: AppUIVersion,
            dataVersion: props.route.params.dataVersion,
            appVersionCode: AppVersionCode,
            appGUID: pwaGUID(),
            bodyTags: props.route.params.bodyTags,
            category: data.caseCode,
            userId: data.userId,
            questionnaireResponses: formatAnswerList(data.answerList)
        };

        const form: FormData = new FormData();
        // form.append('jsonFile', file);
        form.append('requestData', JSON.stringify(params));
        const imageData = reduxState.consultImageData
        const imageIdList = Object.keys(imageData);
        if (imageIdList.length > 0) {
            for (let i = 0; i < imageIdList.length; i++) {
                for (let j = 0; j < imageData[imageIdList[i]].length; j++) {
                    let fileobjMap = imageData[imageIdList[i]][j];
                    let handle = Object.keys(fileobjMap)[0];
                    await dataURItoBlob(imageData[imageIdList[i]][j][handle], form, handle)
                }
            }
        }

        doMultipart('econsult/create_econsult', form).then(
            (response: any) => {
                refreshEConsult()
                AlertService.loaderModal.setLoader(false);
                makePayment(response.consultation, response.wauHashCode);
            }, (error: any) => {
                AlertService.loaderModal.setLoader(true)
            }
        )
    }

    function makePayment(consultationData, wauHashCode) {
        const reduxState = store.getState();
        const params = {
            memberId: consultationData.userId,
            memberName: consultationData.userName,
            consultationId: consultationData.id,
            caseCode: consultationData.category,
            category: consultationData.categoryRM.en,
            consultationHashcode: wauHashCode,
            phoneNumber: checkAlternatePhNumber(consultationData.altCallNumber,
                reduxState.userDetails['phoneNumber'])
        };
        Redux.updateSelectedAayucard({});
        Redux.updateReduxAnswerList({});
        Redux.updateReduxQuestionList([]);
        Redux.updateReduxCurrentAnswer({});
        Redux.updateReduxCurrentQuestion({});
        Redux.updateReduxImageList({});
        Redux.updateConsultationParam({});
        const aayuValidity = checkAayuSubscriptionValidity(reduxState.subscriptionData);
        if (aayuValidity.valid) {
            props.navigation.navigate(ScreenRoute.payment_acs, {
                serviceParams: params, serviceName: 'Remote Consultation',
                onBackPressRoute: ScreenRoute.tab_controller_screen
            });
        } else {
            props.navigation.navigate(ScreenRoute.payment_online, {
                serviceParams: params, serviceName: 'Remote Consultation',
                onBackPressRoute: ScreenRoute.tab_controller_screen
            });
        }
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth }}>
            <CommonHeader navigation={props.navigation} confirmBackpress={true} alertOkColor={'#a32845'}
                alertCancelColor={AppTheme.color.primary} showWarning={true} alertTitle={'You will lose your progress. Is that OK?'}
                alertCancelText={'NO'} alertOkText={'YES'} title='Review Your Answers'></CommonHeader>

            <ScrollView style={{ marginBottom: 60, marginTop: AppTheme.headerHeight }}>

                <View style={[AppStyles.flexRowCenter, { justifyContent: "space-between", marginTop: 16, paddingHorizontal: 16 }]}>
                    <View>
                        <Text numberOfLines={1} style={{ fontSize: 16, marginBottom: 4, color: AppTheme.color.black, width: AppTheme.appWidth - 105, }}>{data.userName}</Text>
                        <Text style={OmsStyles.text16b}>E-Consult for <Text style={{ color: AppTheme.color.green.primary }}>
                            {EConsultUtils.checkCaseCodeLength(data.category)}</Text></Text>
                    </View>
                    <Avatar source={{ uri: EConsultUtils.getCategoryImageNetworkURL(data.caseCode) }}
                        size={60} avatarStyle={{ borderRadius: 150, margin: 6, shadowRadius: 4, shadowOpacity: 0.3 }} />
                </View>

                <HorizontalDivider width={AppTheme.appWidth} marginVertial={8} />

                {
                    data.render ? <View>
                        {
                            data.questionList.map((question, index) => {
                                return <TouchableOpacity onPress={() => {
                                    Redux.updateReduxCurrentAnswer(data.answerList[question['qid']]);
                                    Redux.updateReduxCurrentQuestion(question);
                                    Redux.updateQuestionRenderState(true);
                                    props.navigation.replace(ScreenRoute.questionaire_screen)
                                }}
                                    style={styles.quesContainer} key={index}>
                                    <View style={{ width: AppTheme.appWidth - 72 }}>
                                        <Text style={[OmsStyles.text14, { flexWrap: "wrap" }]}>{data.questionList[index]['qstr']}</Text>
                                        <Text style={[styles.ansText, OmsStyles.text14xb]}>
                                            {renderAnswer(question, data.answerList)}
                                        </Text>
                                    </View>
                                    <View style={styles.cardRightIcon}>
                                        <MaterialIcons name="chevron-right" style={{ color: AppTheme.color.black, fontSize: 25 }} />
                                    </View>
                                </TouchableOpacity>
                            })
                        }
                    </View> : <View />
                }

            </ScrollView>
            <View style={{ position: 'fixed', bottom: 0, zIndex: 10, backgroundColor: AppTheme.color.white }}>
                <TouchableHighlight
                    style={styles.submit}
                    onPress={() => { createConsultation() }}
                    underlayColor='#fff'>
                    <Text style={styles.submitText}>NEXT</Text>
                </TouchableHighlight>
            </View>

            <ActionPopup showPopUp={showExitFlowPopup}
                modalData={ModalContent.ReviewQuestionAnswerBackpress}
                setPopUpOnCancel={() => setExitFlowPopup({ active: false })}
                setPopUpOnOk={() => exitFlowAction()} />

        </View>)

}

export default ReviewAnswers;

const styles = StyleSheet.create(addFontFamilyStyle({
    ansText: {
        paddingTop: 6, flexWrap: "wrap"
    },
    probHead: {
        backgroundColor: '#eff5f5',
        width: '100%',
        padding: 16
    },
    cardRightIcon: {
        width: 25,
        height: 15,
        // backgroundColor: 'blue',
        color: 'blue',
        borderRadius: 50
    },
    quesContainer: {
        justifyContent: 'space-between', flexDirection: 'row',
        padding: 16, borderBottomColor: '#b3cccc', borderBottomWidth: 1, flexWrap: 'wrap'
    },
    submit: {
        bottom: 8,
        margin: 'auto', paddingVertical: 11, backgroundColor: AppTheme.color.blue.cta,
        borderRadius: 4, color: '#ffffff',
        borderColor: AppTheme.color.blue.cta,
        borderWidth: 1,
        width: AppTheme.appWidth - 32,
        alignItems: "center",
        marginLeft: 16
    },
    submitText: {
        color: '#fff',
        textAlign: 'center',
        fontWeight: '900',
        fontSize: 18,
    },

    quesAns: { justifyContent: 'space-between', flexDirection: 'row', flexWrap: 'wrap' }
}))
